module.exports = __webpack_public_path__ + "public/Icons/defaultIconAdmin.svg?ce59b2e6";